import React from 'react';
import "./Message.css";
import { format } from 'timeago.js';
import ProfileSuggestions from './Suggestions';
import WeeklyMatchCountdown from '../WeeklyMatchCountdown';
import ChatSliderWidget, { SLIDER_WIDGET_PREFIX } from './ChatSliderWidget';
import ChatLocationWidget, { LOCATION_WIDGET_PREFIX } from './ChatLocationWidget';

// Tapping a quick reply sends its label as if typed — MessengerInput
// listens for this event and submits it through the normal send path.
export const QUICK_REPLY_EVENT = 'chatQuickReply';

const Message = React.memo(({ message, own, otherUserPic, reciverUserPic, onToSuggestionProfileForCSS, showQuickReplies = false }) => {
  console.log('message', message);

  if (message.sender === 'system') {
    return (
      <div className="message-system-notice">
        <span>{message.text}</span>
        <span className="message-system-time">{format(message.createdAt)}</span>
      </div>
    );
  }

  // Countdown-mode welcome flow ends with the live round countdown itself,
  // sent as a real bot message (sender = communityId, so conversation
  // last-read/last-message tracking works normally) whose text carries a
  // magic prefix + JSON instead of something meant to be read as text —
  // same widget shown on the Community Home vc2 hero, so the timing reads
  // identically in both places. Prefix must match COUNTDOWN_WIDGET_PREFIX
  // in backend/controllers/Functions/triggerWelcomeMessage.js.
  const COUNTDOWN_WIDGET_PREFIX = '__COUNTDOWN_WIDGET__';
  if (typeof message.text === 'string' && message.text.startsWith(COUNTDOWN_WIDGET_PREFIX)) {
    let widgetData = {};
    try { widgetData = JSON.parse(message.text.slice(COUNTDOWN_WIDGET_PREFIX.length)); } catch { /* ignore malformed payload */ }
    if (typeof widgetData.dayOfWeek !== 'number' || typeof widgetData.hour !== 'number') return null;
    return (
      <div className="message-countdown-widget">
        <WeeklyMatchCountdown dayOfWeek={widgetData.dayOfWeek} hour={widgetData.hour} label={widgetData.label} light />
      </div>
    );
  }

  const quickReplies = showQuickReplies && !own && message.quickReplies?.length > 0 && (
    <div className="messageQuickReplies">
      {message.quickReplies.map((r) => (
        <button
          key={r.id}
          type="button"
          className="messageQuickReply"
          onClick={() => window.dispatchEvent(new CustomEvent(QUICK_REPLY_EVENT, { detail: { text: r.label } }))}
        >
          {r.label}
        </button>
      ))}
    </div>
  );

  // A box for their town the bot put in the chat (ChatLocationWidget.js).
  if (typeof message.text === 'string' && message.text.startsWith(LOCATION_WIDGET_PREFIX)) {
    return (
      <>
        <ChatLocationWidget />
        {quickReplies}
      </>
    );
  }

  // A slider from their profile the bot put in the chat for them to set
  // themselves (ChatSliderWidget.js), e.g. how far away people can be.
  if (typeof message.text === 'string' && message.text.startsWith(SLIDER_WIDGET_PREFIX)) {
    let sliderData = {};
    try { sliderData = JSON.parse(message.text.slice(SLIDER_WIDGET_PREFIX.length)); } catch { /* ignore malformed payload */ }
    if (typeof sliderData.field !== 'string') return null;
    return (
      <>
        <ChatSliderWidget communityId={message.communityId} field={sliderData.field} />
        {quickReplies}
      </>
    );
  }

  return (
    <div className={`message ${own ? "own" : ""}`}>
      <div className="messageTop">
        <img 
          className="messageImg"
          src={own ? reciverUserPic[0] : otherUserPic} 
          alt=""
        />
        <div className="messageText" dangerouslySetInnerHTML={{ __html: message.text }}></div>
      </div>
      <div> 
        {message?.suggestions?.length > 0 && (
          <ProfileSuggestions 
            userIds={message.suggestions} 
            communityId={message.communityId} 
            communityPic={otherUserPic} 
            conversationId={message.conversationId}
            onSuggestionProfileClick={onToSuggestionProfileForCSS}
          />
        )}
      </div>
      {quickReplies}
      <div> 
        {message.leaveConvoAfter && (
          <div className="leftConversation"> {message.communityName} left the conversation </div>
        )}
      </div>
      <div className="messageBottom">
        {format(message.createdAt)}
        {own && (
          <span className={`messageStatus ${message.status || 'sent'}`}>
            {message.status === 'pending' && '⏳'}
            {message.status === 'sent' && '✓'}
            {message.status === 'failed' && '❌'}
            {!message.status && '✓'}
          </span>
        )}
      </div>
    </div>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function to prevent unnecessary re-renders
  return (
    prevProps.message._id === nextProps.message._id &&
    prevProps.message.status === nextProps.message.status &&
    prevProps.showQuickReplies === nextProps.showQuickReplies &&
    prevProps.own === nextProps.own &&
    prevProps.otherUserPic === nextProps.otherUserPic &&
    prevProps.reciverUserPic === nextProps.reciverUserPic &&
    prevProps.onToSuggestionProfileForCSS === nextProps.onToSuggestionProfileForCSS
  );
});

export default Message;


//2025

// import React from 'react';
// import "./Message.css";
// import {format} from 'timeago.js'
// import ProfileSuggestions from './Suggestions';

// const Message = ({message, own, otherUserPic, reciverUserPic}) => {

//   console.log('message',message)
 
//   return (
//     <div className={`message ${own ? "own" : ""}`}>
//       <div className="messageTop">
//         <img 
//           className="messageImg"
//           src={own ? reciverUserPic[0] : otherUserPic} 
//           alt=""
//         />
//         <div className="messageText" dangerouslySetInnerHTML={{ __html: message.text }}></div>
//       </div>
//       <div> 
//         {message?.suggestions?.length > 0 && <ProfileSuggestions userIds={message.suggestions} communityId={message.communityId} communityPic={otherUserPic} conversationId={message.conversationId}/>}
//       </div>
//       <div> 
//         {message.leaveConvoAfter && <div className="leftConversation"> {message.communityName} left the conversation </div>}
//       </div>
//       <div className="messageBottom">{format(message.createdAt)}</div>
//     </div>
//   ); 

// }

// export default Message;    





// return (
//   <div className={own ? "message own" : "message"}>
//       <div className="messageTop">
//           <img 
//               className="messageImg"
//               src= {own ? "https://static.vecteezy.com/system/resources/previews/034/222/551/non_2x/bearded-black-man-winking-smiling-2d-avatar-illustration-african-american-adult-sparkling-cartoon-character-face-portrait-friendly-flirty-guy-flat-color-user-profile-image-isolated-on-white-vector.jpg" : otherUserPic } 
//               alt=""
//           />
// {/* Use dangerouslySetInnerHTML to render the HTML content */}
// <div className="messageText" dangerouslySetInnerHTML={{ __html: message.text }}></div>
//       </div>
//       <div> 
//         {message.suggestions.length > 0  ?  <ProfileSuggestions userIds={message.suggestions} communityId={message.communityId} communityPic={otherUserPic} conversationId={message.conversationId}/>  : null /* <label> NO! suggestions </label> */}
//       </div>
//       <div className="messageBottom">{format(message.createdAt)}</div>
//   </div>
// ); 
// }




// import React from 'react';
// import "./Message.css";
// import {format} from 'timeago.js'

// const Message = ({message, own}) => {
//   return (
//     <div className={own ? "message own" : "message"}>
//         <div className="messageTop">
//             <img 
//                 className="messageImg"
//                 src="https://static.vecteezy.com/system/resources/previews/034/222/551/non_2x/bearded-black-man-winking-smiling-2d-avatar-illustration-african-american-adult-sparkling-cartoon-character-face-portrait-friendly-flirty-guy-flat-color-user-profile-image-isolated-on-white-vector.jpg" 
//                 alt=""
//             />
//             <p className="messageText">{message.text}</p>
//         </div>
//         <div className="messageBottom">{format(message.createdAt)}</div>
//     </div>
//   ); 
// }

// export default Message;    


//PROFILE SUGGESTIONS: 

// import React, { useState } from 'react';
// import "./Message.css";

// // Assuming you have a list of profiles like this
// const profiles = [
//   {
//     id: 1,
//     name: "John Doe",
//     bio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
//     imageUrl: "https://example.com/john.jpg"
//   },
//   {
//     id: 2,
//     name: "Jane Doe",
//     bio: "Pellentesque habitant morbi tristique senectus et netus.",
//     imageUrl: "https://example.com/jane.jpg"
//   },
//   {
//     id: 3,
//     name: "Jim Doe",
//     bio: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
//     imageUrl: "https://example.com/jim.jpg"
//   }
// ];

// const Message = () => {
//   const [selectedProfiles, setSelectedProfiles] = useState([]);

//   const handleCheckboxChange = (profileId) => {
//     setSelectedProfiles(prev => {
//       if (prev.includes(profileId)) {
//         return prev.filter(id => id !== profileId);
//       } else {
//         return [...prev, profileId];
//       }
//     });
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     console.log("Selected Profiles: ", selectedProfiles);
//     // Here you can do whatever you need with the selected profiles
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       {profiles.map(profile => (
//         <div key={profile.id} className="profile">
//           <img className="profileImg" src={profile.imageUrl} alt={profile.name} />
//           <p className="profileBio">{profile.bio}</p>
//           <label>
//             <input  
//               type="checkbox"
//               checked={selectedProfiles.includes(profile.id)}
//               onChange={() => handleCheckboxChange(profile.id)}
//             />
//             Connect with this person?
//           </label>
//         </div>
//       ))}
//       <button type="submit">Submit</button>
//     </form>
//   );
// }

// export default Message;